export const linksMenuExtensionType = 'com.atlassian.confluence.links-menu';
